import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const UserProfile = lazy(() => import("../pages/user-profile"));

export const UserProfileRouter = [
  {
    path: "/profile",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "/profile",
        element: (
          <Suspense fallback={<Backdrop />}>
            <UserProfile />
          </Suspense>
        ),
      },
    ],
  },
];
